module.exports = __webpack_public_path__ + "media/images/flags/nr-70356aeaffd17f715573c3986adf3263.svg";